import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import ProtectedRoute from "./components/ProtectedRoute";
import GuestRoute from "./components/GuestRoute";
import ScrollToTop from "./utils/ScrollToTop";
import "./styles/global.css";

// Public Pages
import Home from './pages/Home';
import Browse from './pages/Browse';
import OpportunityDetail from './pages/OpportunityDetail';

import NotFound from './pages/NotFound';

// Auth Pages (Student)
import Login from './pages/Login';
import Register from './pages/Register';
import VerifyEmail from './pages/VerifyEmail';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';

// Student Pages
import Dashboard from './pages/Dashboard';

// Company Pages
import CompanyLogin from './pages/company/CompanyLogin';
import CompanyRegister from './pages/company/CompanyRegister';
import CompanyDashboard from './pages/company/CompanyDashboard';
import CompanyProfile from './pages/company/CompanyProfile';
import CompanyJobs from './pages/company/CompanyJobs';
import PostJob from './pages/company/PostJob';
import CompanyApplicants from './pages/company/CompanyApplicants';

// Admin Pages
import AdminLayout from './components/admin/AdminLayout';
import AdminLogin from './pages/AdminLogin';
import AdminOverview from './pages/admin/AdminOverview';
import AdminStudents from './pages/admin/AdminStudents';
import AdminCompanies from './pages/admin/AdminCompanies';
import AdminJobs from './pages/admin/AdminJobs';
import AdminLogs from './pages/admin/AdminLogs';
import AdminOpportunities from './pages/Admin'; // Legacy name for Opportunities management

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<Home />} />
        <Route path="/browse" element={<Browse />} />
        <Route path="/opportunity/:id" element={<OpportunityDetail />} />
        
        {/* Student Auth */}
        <Route path="/login" element={<GuestRoute><Login /></GuestRoute>} />
        <Route path="/register" element={<GuestRoute><Register /></GuestRoute>} />
        <Route path="/verify-email/:id" element={<VerifyEmail />} />
        <Route path="/forgot-password/:userType" element={<GuestRoute><ForgotPassword /></GuestRoute>} />
        <Route path="/reset-password" element={<GuestRoute><ResetPassword /></GuestRoute>} />
        
        {/* Company Auth */}
        <Route path="/company/login" element={<GuestRoute><CompanyLogin /></GuestRoute>} />
        <Route path="/company/register" element={<GuestRoute><CompanyRegister /></GuestRoute>} />
        <Route path="/verify-company-email/:id" element={<VerifyEmail />} />
        
        {/* Admin Auth */}
        <Route path="/admin/login" element={<GuestRoute><AdminLogin /></GuestRoute>} />
        
        {/* Student Routes */}
        <Route path="/dashboard" element={
          <ProtectedRoute allowedRoles={['student']}>
            <Dashboard />
          </ProtectedRoute>
        } />
        
        {/* Company Routes */}
        <Route path="/company/dashboard" element={
          <ProtectedRoute allowedRoles={['company']}>
            <CompanyDashboard />
          </ProtectedRoute>
        } />
        <Route path="/company/profile" element={
          <ProtectedRoute allowedRoles={['company']}>
            <CompanyProfile />
          </ProtectedRoute>
        } />
        <Route path="/company/jobs" element={
          <ProtectedRoute allowedRoles={['company']}>
            <CompanyJobs />
          </ProtectedRoute>
        } />
        <Route path="/company/jobs/new" element={
          <ProtectedRoute allowedRoles={['company']}>
            <PostJob />
          </ProtectedRoute>
        } />
        <Route path="/company/jobs/edit/:id" element={
          <ProtectedRoute allowedRoles={['company']}>
            <PostJob />
          </ProtectedRoute>
        } />
        <Route path="/company/applicants" element={
          <ProtectedRoute allowedRoles={['company']}>
            <CompanyApplicants />
          </ProtectedRoute>
        } />
        
        {/* Admin Routes */}
        <Route path="/admin" element={
          <ProtectedRoute allowedRoles={['admin']}>
            <AdminLayout />
          </ProtectedRoute>
        }>
          <Route index element={<AdminOverview />} />
          <Route path="students" element={<AdminStudents />} />
          <Route path="companies" element={<AdminCompanies />} />
          <Route path="jobs" element={<AdminJobs />} />
          <Route path="opportunities" element={<AdminOpportunities />} />
          <Route path="applications" element={<AdminOpportunities defaultTab="applications" />} />
          <Route path="logs" element={<AdminLogs />} />
        </Route>
        
        {/* Fallback */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default App;
